import { render, staticRenderFns } from "./chooseUs.vue?vue&type=template&id=fe6a7b88"
import script from "./chooseUs.vue?vue&type=script&lang=js"
export * from "./chooseUs.vue?vue&type=script&lang=js"
import style0 from "./chooseUs.vue?vue&type=style&index=0&id=fe6a7b88&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports